import type { ExtractPropTypes, PropType, ExtractPublicPropTypes } from 'vue'
import {
  selectProps as elSelectProps,
  selectEmits as elSelectEmits,
  type SelectProps as ElSelectProps,
} from 'element-plus'
import { apiProps } from '@el-plus/utils/props'

export type SelectOption = NonNullable<ElSelectProps['options']>[number]
export const inheritSelectProps = {
  ...elSelectProps,
  clearable: {
    ...elSelectProps.clearable,
    default: true,
  },
} as const
const expandSelectProps = {
  ...apiProps,
  // 回显文本:异步 value 到达时,用 desc 构造占位项(只读)
  desc: {
    type: String,
    default: '',
  },
  disabledOption: {
    type: Function as PropType<(item: SelectOption) => boolean>,
    default: () => false,
  },
  labelKey: {
    type: String,
    default: 'label',
  },
  valueKey: {
    type: String,
    default: 'value',
  },
  formatLabel: {
    type: Function as PropType<(item: SelectOption) => string>,
  },
  // api模式生效
  lazy: Boolean,
  // option是否同时展示code label, 默认值展示label, 传string展示指定字段
  codeInLabel: {
    type: [String, Boolean] as PropType<boolean | string>,
  },
}
export const selectProps = {
  ...inheritSelectProps,
  ...expandSelectProps,
} as const
export const expandSelectPropsKeys = Object.keys(expandSelectProps)

export type SelectProps = ExtractPropTypes<typeof selectProps>
export type SelectPropsPublic = ExtractPublicPropTypes<typeof selectProps>

/* eslint-disable @typescript-eslint/no-unused-vars */
export const selectEmits = {
  ...elSelectEmits,
  change: (
    value: SelectProps['modelValue'],
    item?: SelectOption | SelectOption[],
  ) => true,
}
/* eslint-enable @typescript-eslint/no-unused-vars */
export type SelectEmits = typeof selectEmits
export const selectEmitsKeys = Object.keys(selectEmits)
